export default __webpack_public_path__ + "static/media/iam_background_xl2.7f6041c2.jpg";